import styles from './SearchForm.module.scss'
import React from 'react'

type Props = {
  children: React.ReactNode,
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void,
}

const SearchForm = (props: Props) => {
  return (
    <form
      className={styles.component}
      onSubmit={props.onSubmit}
    >
      {props.children}
    </form>
  )
}

export default SearchForm